import React, { useEffect, useState } from 'react'
import styles from '../styles/Partners.module.css'
import VerificationPopup from './modals/VerificationPopup'
import ReactTyped from 'react-typed'
import { BlueCustomButton, HeroSection, TextInput } from './qbStrap'
import Image from 'next/image'
import { Button, FormGroup, Input, Label } from 'reactstrap'
import { PhoneNumberUtil } from "google-libphonenumber";
import 'react-phone-number-input/style.css';
import PhoneInput from '@/components/common/LocalPhoneInput';
import Link from 'next/link'
import content from '../language/ENGLISH.json'
import { toast } from 'sonner'
import { getFreeDemo } from '@/services/signUpServices'
import { useRouter } from 'next/router'
import ThreeStepForm from './common/ThreeStepForm'
import TestimonialSection from './common/TestimonialSection'
import { testimonialData, videoTestimonial } from '@/constants/common'
import TrustFactor from './common/TrustFactor'
import FAQ_mobile from './Industry/FAQ_mobile'
import FrequentQuestions from './homePage/FrequentQuestions'
import MobileTestimonialSection from './common/MobileTestimonialSection'

const Partners = () => {
    const [mobileView, setmobileView] = useState(0);
    const [demoModal, setDemoModal] = useState(false);
    const [value, setValue] = useState()
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [fullname, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [partnerType, setPartnerType] = useState("reseller");
    const [heroReadMore, setHeroReadMore] = useState(false);
    const [phoneNo, setPhoneNo] = useState();
    const [isChecked, setIsChecked] = useState(true);
    const [message, setMessage] = useState("");
    const [phoneCode, setPhoneCode] = useState('');
    const [errors, setErrors] = useState({
        phoneNoError: "",
        fullNameError: "",
        emailError: "",
    })
    const router = useRouter();

    const { iAgree, privacyTerms, allowQueuebuster } = content.contactSales
    const { testimonialHeadText } = content.testimonial;

    const EMAIL_VALIDATION_REGEX =
        /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;

    const partners = [
        { height: "4rem", width: "13rem", image: "/assets/MICROSOFT DYNAMICS.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/ZOHO.webp", altText: "microsoft dynamics" },
        // { height: "4rem", width: "13rem", image: "/assets/GRAY MATTER.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/SHOPIFY.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/ZOMATO.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/SWIGGY.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/TALLY.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/ADSR.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/GSP.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/PAYTM MLYAL.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/Hardwares/epson.webp", altText: "microsoft dynamics" },     ////
        { height: "5rem", width: "10rem", image: "/assets/Integration/Hardwares/essae.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/Hardwares/imini.webp", altText: "microsoft dynamics" },  ////////
        { height: "5rem", width: "10rem", image: "/assets/Integration/Hardwares/ingenico.webp", altText: "microsoft dynamics" },
        // { height: "4rem", width: "13rem", image: "/assets/Integration/Hardwares/newland.web", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/Hardwares/pax.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/Hardwares/posiflex.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/Hardwares/sunmi.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/Hardwares/tactilion.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/Hardwares/verifone.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/Hardwares/TVSE LOGO.png", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/Hardwares/tactilion.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/paytm.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/razorpay.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/paypal.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/ezetap.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/Mosambee.webp", altText: "microsoft dynamics" },
        // { height: "4rem", width: "10rem", image: "/assets/Integration/payswiff.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/Pinelab.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/geidea-logo.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/mswipe.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/payu.webp", altText: "microsoft dynamics" },
        { height: "5rem", width: "10rem", image: "/assets/Integration/plural.webp", altText: "microsoft dynamics" },
    ]

    const partnersContent = [
        {
            id: 1,
            heading: <>Maxed Out Revenue</>,
            desc: "As a potential partner, teaming up with QueueBuster POS opens doors to numerous business opportunities. Our innovative Android-first POS solutions are designed to cater to every business, ensuring a wide market reach.",
            points: <>
                <ul>
                    <li><b>Expanded Market Reach:</b> Tap into diverse business sectors with our versatile POS.</li>
                    <li><b>Recurring Income:</b> Benefit from continuous revenue through subscription-based services.</li>
                    <li><b>Growth Potential:</b> Leverage our technology to grow your client base and profits.</li>
                </ul>
            </>,
            image: "/assets/partners/asian-worker.webp",
            style: { height: mobileView ? '35rem' : '60rem' }
        },
        {
            id: 2,
            heading: <>Spotlight On Your Services</>,
            desc: "By partnering with QueueBuster POS, you enhance your service offerings with the latest in POS technology. Our solutions provide comprehensive business management tools that your clients will love.",
            points: <>
                <ul>
                    <li><b>Comprehensive Solutions:</b> Offer all-in-one POS systems to your clients.</li>
                    <li><b>Advanced Features:</b> Provide cutting-edge features like real-time analytics and mobile POS.</li>
                    <li><b>Customization Options:</b> Tailor solutions to fit the unique needs of each business.</li>
                    <li><b>Customer Loyalty:</b> Strengthen client relationships with superior technology.</li>
                </ul>
            </>,
            image: "/assets/partners/gst-returns.webp",
            style: { height: mobileView ? '30rem' : '50rem' }
        },
        {
            id: 3,
            heading: <>Merge And Multiply</>,
            desc: "Join forces with QueueBuster POS to become a pivotal part of transforming businesses. Our POS solutions drive efficiency and growth, making you an indispensable partner to your clients.",
            points: <>
                <ul>
                    <li><b>Support & Training:</b> Access dedicated support and comprehensive training resources.</li>
                    <li><b>Marketing Assistance:</b> Benefit from co-branded marketing efforts to boost visibility.</li>
                    <li><b>Exclusive Tools:</b> Utilize exclusive partner tools to enhance yo   ur service delivery.</li>
                    <li><b>Innovation Leader:</b> Align with India's most innovative Android-first POS company and stay ahead of the curve.</li>
                </ul>
            </>,
            image: "/assets/partners/data-feed.webp",
            style: { height: mobileView ? '28rem' : '50rem', width: mobileView ? '100%' : '70rem', marginTop: mobileView ? '0' : '7rem' }
        },
    ]

    const partnerTypeOptions = [
        {
            label: "Reseller",
            value: "reseller"
        },
        {
            label: "Hardware Partner",
            value: "hardwarePartner"
        },
        {
            label: "Software Partner",
            value: "softwarePartner"
        },
        {
            label: "Payment Partner",
            value: "paymentPartner"
        },
        {
            label: "Others",
            value: "others"
        },
    ]

    const forCustomers = [
        {
            id: 1,
            title: "Profitability",
            desc: "Increase your revenue with attractive profit-sharing models designed to maximize returns on every client you onboard.",
            points: <ul>
                <li>Attractive profit-sharing models</li>
                <li>High ROI on client acquisitions</li>
                <li>Continuous revenue streams</li>
                <li>Performance-based incentives</li>
            </ul>,
            icon: "/assets/partners/profit.svg",
            color: "#F2F9FA"
        },
        {
            id: 2,
            title: "Innovation",
            desc: "Stay ahead with the latest POS technology that ensures your brand is recognized as a leader in cutting-edge business solutions.",
            points: <ul>
                <li>Cutting-edge POS technology</li>
                <li>Constant updates and enhancements</li>
                <li>Future-ready business solutions</li>
                <li>Distinct market differentiation</li>
            </ul>,
            icon: "/assets/partners/innovation.svg",
            color: "#FFF6E4"
        },
        {
            id: 3,
            title: "Support",
            desc: "Receive dedicated support and training resources to empower your team and enhance your service delivery.",
            points: <ul>
                <li>Dedicated partner support</li>
                <li>Comprehensive training programs</li>
                <li>24/7 technical assistance</li>
                <li>Marketing and sales resources</li>
            </ul>,
            icon: "/assets/partners/support.svg",
            color: "#FFF3F3"
        },
        {
            id: 4,
            title: "Reach",
            desc: "Expand your market presence by tapping into diverse business sectors, from retail to hospitality, with our versatile POS systems.",
            points: <ul>
                <li>Access to diverse business sectors</li>
                <li>Nationwide market presence</li>
                <li>Scalable POS solutions</li>
                <li>Customizable to client needs</li>
            </ul>,
            icon: "/assets/partners/reach.svg",
            color: "#EDFEF9"
        },
        {
            id: 5,
            title: "Growth",
            desc: "Leverage our comprehensive business management tools to grow your client base, fostering long-term relationships and consistent income streams.",
            points: <ul>
                <li>Expand client base with ease</li>
                <li>Long-term relationship building</li>
                <li>Robust business management tools</li>
                <li>Consistent income growth opportunities</li>
            </ul>,
            icon: "/assets/partners/growth.svg",
            color: "#FCF5FF"
        },
    ]
    const [choosedContent, setChoosedContent] = useState({ title: forCustomers[0].title, desc: forCustomers[0].desc, points: forCustomers[0].points, color: forCustomers[0].color });

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    useEffect(() => {
        handlePhoneNumberChange();
    }, [value])

    const handlePhoneNumberChange = () => {
        const phoneUtil = PhoneNumberUtil.getInstance();
        try {
            const parsedNumber = phoneUtil.parse(value, "");
            const phoneNumber = phoneUtil.getNationalSignificantNumber(parsedNumber);
            const countryCode = parsedNumber.getCountryCode();
            if (errors?.phoneNoError && phoneNumber?.length === 10) {
                setErrors({ ...errors, phoneNoError: "" })
            } else {
                setErrors({ ...errors, phoneNoError: "Please enter valid phone number" })
            }
            setPhoneCode(countryCode);
            setPhoneNo(phoneNumber);
        } catch (error) {
            console.error("Error parsing phone number:", error);
            setPhoneNo("");
        }
    }

    const partnersForm = () => {
        const storedSource = localStorage.getItem("sources");
        console.log("----data----", errors);
        if (!isChecked)
            alert('Please agree to the terms and conditions')
        if (isChecked && errors?.fullNameError === "" && errors?.emailError === "" && errors?.phoneNoError === "") {
            let data = {
                countryCode: phoneCode,
                phone: phoneNo,
                name: fullname,
                email: email,
                message: message,
                partnerType: partnerType,
                source: storedSource ? JSON.parse(storedSource) : "Enterprise Sales",
                feature: "Partner Program",
            }
            toast.promise(getFreeDemo(data, router), {
                loading: "Loading...",
                success: (data) => {
                    localStorage.removeItem("sources")
                    localStorage.removeItem("registeredNo")
                    return `${data}`;
                },
                error: (data) => {
                    return `${data}`;
                },
            });
            // console.log("----data----", data);
        }
    }
    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is the process for becoming a local partner with QueueBuster?
                </span>
            ),
            des: "To become a local partner with QueueBuster, you need to visit our partnership page on the website and fill out the application form. Once submitted, our partnership team will review your application and contact you to discuss the next steps, which include an initial meeting, agreement on terms, and onboarding.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster ensure that local partners receive adequate training and support?
                </span>
            ),
            des: "QueueBuster provides comprehensive training programs for all local partners. This includes online training modules, in-person workshops, and dedicated support resources. We also offer ongoing support through our customer service team and partner success managers to ensure partners have the assistance they need.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How can software partners integrate their solutions with QueueBuster POS systems?
                </span>
            ),
            des: "Software partners can integrate their solutions with QueueBuster POS systems through our open API. Detailed API documentation is available to guide the integration process, and our technical support team is on hand to assist with any challenges that may arise during integration.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What kind of API documentation and technical support does QueueBuster provide to software partners?
                </span>
            ),
            des: "QueueBuster provides comprehensive API documentation that includes endpoints, usage guidelines, and examples. Additionally, we offer technical support through a dedicated support team that can assist with integration queries and troubleshooting.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Are there co-marketing opportunities available for software partners?
                </span>
            ),
            des: "Yes, QueueBuster offers co-marketing opportunities for software partners. These opportunities include joint webinars, case studies, and co-branded marketing materials to help promote the integrated solutions to a broader audience.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What commission structure does QueueBuster offer to its affiliate partners?
                </span>
            ),
            des: "QueueBuster offers a competitive commission structure to its affiliate partners, which includes a percentage of the sales generated through referrals. The specific percentage and terms can be discussed with our affiliate partnership team upon application.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   How can affiliate partners track their referrals and earnings with QueueBuster?
                </span>
            ),
            des: "Affiliate partners can track their referrals and earnings through QueueBuster’s affiliate portal. The portal provides detailed reports on referral activities, sales conversions, and commission earnings, enabling partners to monitor their performance effectively.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How can someone apply to become an affiliate partner with QueueBuster?
                </span>
            ),
            des: "To apply as an affiliate partner, visit the affiliate program page on the QueueBuster website and complete the application form. Once submitted, the application will be reviewed, and eligible applicants will be contacted with further details and onboarding instructions.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   What are the key benefits for fintech partners working with QueueBuster?
                </span>
            ),
            des: "Fintech partners benefit from QueueBuster’s extensive market reach, robust technology platform, and collaborative development opportunities. Additionally, partners can leverage QueueBuster’s industry expertise, co-marketing efforts, and integration support to enhance their offerings and reach new customers",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster ensure compliance with financial regulations and standards for fintech integrations?
                </span>
            ),
            des: "QueueBuster adheres to all relevant financial regulations and industry standards to ensure compliance. This includes regular audits, data security measures, and collaboration with regulatory bodies to stay updated on compliance requirements. Our integration processes are designed to meet these standards, providing secure and compliant solutions.",
            id: 10,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What types of payment solutions can be integrated with QueueBuster POS systems?
                </span>
            ),
            des: "QueueBuster POS systems can integrate with a wide range of payment solutions, including credit and debit card processors, mobile wallets, UPI, and other digital payment platforms. Our flexible API allows for seamless integration with various payment providers.",
            id: 11,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What are the key advantages of payment solutions providers partnering with QueueBuster?
                </span>
            ),
            des: "Payment solutions providers partnering with QueueBuster gain access to our extensive customer base, streamlined integration processes, and co-marketing opportunities. This partnership enhances their market presence and offers additional revenue streams through joint solutions.",
            id: 12,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Does QueueBuster offer any co-branding opportunities for payment solutions providers?
                </span>
            ),
            des: "Yes, QueueBuster offers co-branding opportunities for payment solutions providers. This includes joint marketing campaigns, co-branded promotional materials, and shared branding on customer interfaces, enhancing visibility and brand recognition for both parties.",
            id: 13,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   How can payment solutions providers ensure seamless transaction processing with QueueBuster POS?
                </span>
            ),
            des: "Payment solutions providers can ensure seamless transaction processing by integrating their systems with QueueBuster’s POS using our API. Our technical support team assists with the integration process to ensure smooth and reliable transaction processing.",             
            id: 14,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   What are the benefits of becoming a software reseller partner with QueueBuster?
                </span>
            ),
            des: "As a software reseller partner, you benefit from exclusive access to QueueBuster’s products, training and certification programs, sales and marketing support, and attractive commission structures. This partnership enables you to expand your product portfolio and increase your revenue.",
            id: 15,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                     How does QueueBuster assist reseller partners in driving sales and customer engagement?
                </span>
            ),
            des: "QueueBuster assists reseller partners by providing sales training, marketing materials, and co-branded promotional campaigns. We also offer ongoing support through our partner success team to help resellers effectively engage customers and close sales.",
            id: 16,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What kind of training and certification programs are available for software reseller partners?
                </span>
            ),
            des: "QueueBuster offers comprehensive training and certification programs for software reseller partners. These programs include product training, sales techniques, and technical certification to ensure resellers are well-equipped to promote and support QueueBuster solutions.",
            id: 17,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Are there any exclusive discounts or promotions for QueueBuster’s reseller partners?
                </span>
            ),
            des: "Yes, QueueBuster provides exclusive discounts and promotions for reseller partners. These incentives are designed to help resellers offer competitive pricing and attract more customers.",
            id: 18,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   How can a company apply to become a software reseller partner with QueueBuster?
                </span>
            ),
            des: "To apply as a software reseller partner, visit the reseller partnership page on the QueueBuster website and complete the application form. Our partnership team will review the application and contact eligible companies with further details and onboarding instructions.",
            id: 19,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   How can partnering with QueueBuster POS help my business grow?
                </span>
            ),
            des: "Partnering with QueueBuster POS can significantly boost your business growth by providing access to advanced POS technology that caters to various industries. By offering state-of-the-art POS solutions, you can attract a wider client base and enhance your service portfolio. Our profit-sharing models ensure that you earn continuous revenue streams from the clients you onboard. Additionally, with QueueBuster POS, you can leverage marketing assistance and dedicated support to expand your market presence and maximize your business potential.",
            id: 20,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   What types of businesses can benefit from QueueBuster POS solutions?
                </span>
            ),
            des: "QueueBuster POS solutions are versatile and can benefit a wide range of businesses, including retail stores, restaurants, cafes, salons, and more. Whether you run a small boutique or a large franchise, our POS systems are designed to streamline operations, improve customer experiences, and boost efficiency. The customizable nature of our solutions means that they can be tailored to fit the unique needs of any business, ensuring maximum utility and satisfaction.",
            id: 21,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   How does QueueBuster POS support the growth of small and medium-sized enterprises (SMEs)?
                </span>
            ),
            des: "QueueBuster POS supports the growth of SMEs by providing cost-effective and scalable POS solutions that help manage and optimize business operations. Our systems offer real-time analytics, inventory management, and customer relationship management tools, which are crucial for making informed business decisions. By automating routine tasks, SMEs can focus more on strategic growth initiatives and customer service, ultimately driving business expansion and profitability.",
            id: 22,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   What kind of training and support does QueueBuster POS provide to its partners?
                </span>
            ),
            des: "As a QueueBuster POS partner, you will receive comprehensive training and support to ensure you can effectively use and promote our POS solutions. We offer detailed training programs for your team, covering everything from system setup to advanced feature usage. Additionally, our dedicated support team is available 24/7 to assist with any technical issues or questions. We also provide marketing resources to help you effectively market and sell our POS solutions to your clients.",
            id: 23,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   Can I customize QueueBuster POS solutions to meet specific client needs?
                </span>
            ),
            des: "Yes, QueueBuster POS solutions are highly customizable to meet the specific needs of your clients. Our systems can be tailored to include features that are most relevant to the business, whether it’s advanced inventory management for retail or table management for restaurants. This flexibility ensures that each client gets a POS solution that fits perfectly with their operational requirements, enhancing their business efficiency and customer service.",
            id: 24,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   How do QueueBuster POS systems enhance customer experiences?
                </span>
            ),
            des: "QueueBuster POS systems enhance customer experiences by providing fast, efficient, and seamless transaction processes. Features like mobile POS, real-time analytics, and customer loyalty programs help businesses deliver personalized and prompt service. For example, a restaurant can use our POS system to manage table reservations, track orders in real time, and offer customized promotions based on customer preferences. This level of service not only improves customer satisfaction but also fosters loyalty and repeat business.",
            id: 25,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   How does QueueBuster POS support API integration and plugins to enhance business operations?
                </span>
            ),
            des: "QueueBuster POS offers robust API integration and a wide range of plugins designed to streamline and enhance business operations. Our API allows seamless connectivity with various third-party applications, enabling businesses to integrate their existing software solutions with our POS system. This flexibility ensures that businesses can maintain their current workflows while benefiting from the advanced features of QueueBuster POS. Additionally, our extensive library of plugins provides businesses with the tools they need to customize their POS system to meet specific operational requirements, whether it's integrating with e-commerce platforms, accounting software, or customer loyalty programs. By partnering with QueueBuster POS, you can offer your clients a versatile and adaptable POS solution that grows with their business.",
            id: 26,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   What are the benefits of QueueBuster POS’s real-time analytics for businesses?
                </span>
            ),
            des: "Real-time analytics provided by QueueBuster POS systems allow businesses to make data-driven decisions quickly. By having access to up-to-date sales data, inventory levels, and customer behavior insights, businesses can identify trends, optimize inventory management, and adjust their strategies to meet market demands. For instance, a retail store can use real-time analytics to track which products are selling fast and which are not, enabling them to restock popular items and create promotions for slow-moving inventory.",
            id: 27,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                  How secure are QueueBuster POS systems for handling transactions and data?
                </span>
            ),
            des: "QueueBuster POS systems are designed with robust security features to ensure the safety of all transactions and data. We use advanced encryption technologies to protect sensitive information, and our systems comply with industry standards for data security. Regular updates and security patches are also provided to keep the systems secure from potential threats. This ensures that both businesses and their customers can trust the integrity of the POS system.",
            id: 28,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   How can QueueBuster POS help businesses manage their inventory more effectively?
                </span>
            ),
            des: "QueueBuster POS offers advanced inventory management features that help businesses track stock levels, manage orders, and prevent overstocking or stockouts. The system provides real-time updates on inventory status, automatic reorder alerts, and detailed reports on inventory movements. This helps businesses maintain optimal stock levels, reduce waste, and ensure that they always have the right products available for their customers. For example, a grocery store can use these features to manage perishable items efficiently, reducing losses and improving profitability.",
            id: 29,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   What are the marketing benefits of partnering with QueueBuster POS?
                </span>
            ),
            des: "Partnering with QueueBuster POS provides several marketing benefits. As a partner, you gain access to co-branded marketing materials, which can enhance your brand’s visibility and credibility. We also offer marketing support to help you create effective campaigns that highlight the advantages of our POS solutions. By promoting QueueBuster POS, you can attract more clients looking for innovative and reliable POS systems, thereby increasing your market reach and revenue potential. Additionally, our advanced analytics can provide insights into marketing performance, helping you refine your strategies for better results.",
            id: 30,
            activeIndex: 0,
        },
    ]
    return (
        <>
        <div className={styles.verificationPopupOverride}>
            <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url(/assets/partners/partners-mobile.webp)" }}>
                        <div>
                            <h1 className={styles.heading}>
                                <span>Together, Let’s Work For a Cause With The Help of POS</span><br />
                            </h1>
                            <p className={styles.desc} style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>Let's collaborate to assist merchants in improving their businesses. Through our exclusive partner policy, you will be integrating with our ecosystem and resources for developing, expanding, and growing your business with QueueBuster. So are you ready to bust the retail-tech queues with us?</p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className='orange_btn' onClick={() => (setDemoModal(true), setHeading("Contact Sales"))}>Connect with us</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 4.3rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/partners/hero-img.webp"
                            heading={<>Together, Let’s Work For a Cause<br /> With The Help of POS</>}
                            orangeBtn
                            description={"Let's collaborate to assist merchants in improving their businesses. Through our exclusive partner policy, you will be integrating with our ecosystem and resources for developing, expanding, and growing your business with QueueBuster. So are you ready to bust the retail-tech queues with us?"}
                            setDemoModal={setDemoModal}
                            setHeading={setHeading}
                            outlinedBtn={true}
                        />
                    </div>
            }
            {
                mobileView ?
                    <div>
                        {
                            partnersContent?.map((ele) => {
                                return (
                                    <div style={{ padding: "0 2rem" }}>
                                        <h3 className={styles.divided_section_heading}>{ele?.heading}</h3>
                                        <div className={styles.divided_section_image_container} style={{ height: ele?.style?.height }}>
                                            <div style={{ ...ele?.style }}><Image src={ele?.image} alt={ele?.heading} fill /></div>
                                        </div>
                                        <p style={{ marginTop: "2rem" }}>{ele?.desc}</p>
                                        {ele?.points}
                                        <p className={styles.link_text}>Talk to us now</p>
                                    </div>
                                )
                            })
                        }
                    </div>
                    :
                    <div className={`${styles.sections} ${styles.divided_section}`}>
                        {
                            partnersContent?.map((ele, idx) => {
                                return (
                                    <div>
                                        {
                                            idx % 2 === 0 &&
                                            <div className={styles.divided_section_image_container}>
                                                <div style={{ ...ele?.style }}><Image src={ele?.image} alt={ele?.heading} fill /></div>
                                            </div>
                                        }
                                        <div style={{ marginTop: "9rem" }} className={styles.divided_section_text_container}>
                                            <h3 className={styles.divided_section_heading}>{ele?.heading}</h3>
                                            <p>{ele?.desc}</p>
                                            {ele?.points}
                                            <p className={styles.link_text}>Talk to us now</p>
                                        </div>
                                        {
                                            idx % 2 !== 0 &&
                                            <div className={styles.divided_section_image_container} style={{ marginTop: "9rem" }}>
                                                <div style={{ ...ele?.style }}><Image src={ele?.image} alt={ele?.heading} fill /></div>
                                            </div>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div >

            }


            <div className={`${styles.sections} ${styles.brands_section}`}>
                <div>
                    <div>
                        <h3>Trusted By The Top Brands</h3>
                        {
                            mobileView ?
                            <div className={styles.software_suggest_img}>
                                <div><Image src="/assets/partners/software-suggest.webp" alt="software suggest" fill /></div>
                            </div>:<></>
                        }
                        <p style={{borderLeft:"2px solid #8ae4f6" ,paddingLeft: '1rem'}}>Activate the most in-demand payment products and tailor a seamless in-store experience for your customers. Our products solve for your business needs, from getting more customers into stores to offering modern day contactless payment experiences and more.</p>
                    </div>
                    {
                        !mobileView &&
                        <div className={styles.software_suggest_img}>
                            <div><Image src="/assets/partners/software-suggest.webp" alt="software suggest" fill /></div>
                        </div>
                    }
                </div>               
                    <div style={{  overflowX: "auto", whiteSpace: "nowrap", display: "flex", gap: "5rem",paddingBottom: "1rem", scrollbarWidth: "none", marginTop:"2rem"  }}>
                        {
                            partners?.map((ele, index) => (
                                <div key={index} style={{ height: ele?.height, width: ele?.width, position: "relative", flexShrink: 0 }}>
                                    <Image src={ele?.image} alt={ele?.altText} fill />
                                </div>
                            ))
                        }
                    </div>
                
            </div>

            <div className={styles.for_clients}>
                <h3>What’s In It For You?</h3>
                <p>Join the league of 50+ leading partners who have already been making 10 X revenue using QueueBuster.</p>
                <div>
                    <div>
                        {
                            forCustomers?.map((ele, idx) => {
                                return (
                                    <div style={{ backgroundColor: ele?.title === choosedContent?.title ? ele?.color : "#fff" }} key={ele?.id} className={styles.choosing_section} onClick={() => setChoosedContent({ ...choosedContent, title: forCustomers[idx].title, desc: forCustomers[idx].desc, points: forCustomers[idx].points, color: forCustomers[idx].color })}>
                                        <div key={ele?.id}><Image src={ele?.icon} alt="title" fill /></div>
                                        <h4>{ele?.title}</h4>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div style={{ backgroundColor: choosedContent?.color }}>
                        <p style={{ width: '70%', marginBottom: "3rem" }}>{choosedContent?.desc}</p>
                        {choosedContent?.points}
                    </div>
                </div>
            </div>
             {
            //  mobileView ? <></>:
            <div className={styles.partners_form}>
                <h3>Want To Partner With Us?</h3>
                <div className={styles.form_container}>
                    <div>
                        <div>
                            <TextInput
                                req={true}
                                type="text"
                                label={`Full Name`}
                                onChange={(e) => {
                                    setFullName(e.target.value);
                                    setErrors({ ...errors, fullNameError: "" });
                                }}
                                value={fullname}
                                feedback={errors.fullNameError ? errors.fullNameError : ""}
                                placeholder="Enter your full name"
                                styles={{
                                    width: "100%",
                                    labelSize: "1.8rem",
                                    fontSize: "1.8rem",
                                    height: "4.5rem",
                                    labelSize: "1.6rem",
                                    labelMarginBottom: "0.5rem"
                                }}
                            />
                        </div>
                        <div style={{height:"8rem"}}>
                            <TextInput
                                req={true}
                                type="text"
                                label={`Email Address`}
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                    setErrors({ ...errors, emailError: "" });
                                }}
                                value={email}
                                feedback={errors.emailError ? errors.emailError : ""}
                                placeholder="Enter your email address"
                                styles={{
                                    width: "100%",
                                    labelSize: "1.8rem",
                                    fontSize: "1.8rem",
                                    height: "4.5rem",
                                    labelSize: "1.6rem",
                                    labelMarginBottom: "0.5rem"
                                }}
                            />
                        </div>
                        <div>
                            <Label>Enter Your Mobile No</Label>
                            <span className='required_asterisk'>*</span>
                            <div className={styles.phone_input_container}>
                                <PhoneInput
                                    placeholder="Mobile number"
                                    value={value}
                                    onChange={setValue}
                                    style={{ width: '100%' }}
                                    defaultCountry='IN' />
                            </div>
                            {errors.phoneNoError && <span className="required_text">{errors.phoneNoError}</span>}
                        </div>
                    </div>
                    <div className={styles.partner_type}>
                        <label>Partner Type</label>
                        <div>
                            {
                                partnerTypeOptions?.map((ele) => {
                                    return (
                                        <div key={ele?.value} className={`${Boolean(ele?.value === partnerType) && styles.selected_partner_type}`} onClick={() => setPartnerType(ele?.value)}>
                                            {ele?.label}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className={styles.message_box}>
                        <label>Message</label>
                        <textarea rows={4} cols={95} placeholder='Write here' onChange={(e) => setMessage(e.target.value)} />
                    </div>
                    <FormGroup check style={{ marginTop: "1rem" }}>
                        <Label check style={{ fontSize: "1.4rem" }}>
                            <Input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() => setIsChecked(!isChecked)}
                            />
                            {iAgree} <Link href='/privacy' style={{ color: '#2a6ab4', textDecoration: 'underline', textUnderlineOffset: '2px' }}>{privacyTerms} </Link> {allowQueuebuster}
                        </Label>
                    </FormGroup>
                    <BlueCustomButton
                        text={"Submit"}
                        style={ mobileView ? {padding: "0 2rem", margin: "2rem 1rem" }:{padding: "0 2rem", margin: "2rem 15rem" }}
                        className={styles.blue_btn}
                        onClick={partnersForm}
                    />
                </div>
            </div>}


            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>
            <TrustFactor />
            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ? 
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"FAQs of  Software"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={"FAQs of QB E-way Billing Software"} />
                }
            </div>
             

        </>
    )
}

export default Partners
